
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24.593","height":"22.021"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Grupo 1082"}},[_c('g',{attrs:{"data-name":"Trazado 382","fill":"#eb445a"}},[_c('path',{attrs:{"d":"M21.588 21.021H3.004a1.98 1.98 0 01-1.733-1.002 1.98 1.98 0 01.003-2.001l9.292-16.021A1.98 1.98 0 0112.296 1a1.98 1.98 0 011.73.997l9.292 16.02a1.98 1.98 0 01.003 2.002 1.98 1.98 0 01-1.733 1.002z"}}),_c('path',{attrs:{"d":"M12.296 2a.983.983 0 00-.865.499l-9.292 16.02a.982.982 0 00-.001 1.001c.086.15.344.501.866.501h18.584c.522 0 .78-.35.866-.5a.982.982 0 00-.001-1.002L13.16 2.5A.983.983 0 0012.296 2m0-2c1.009 0 2.017.499 2.595 1.495l9.292 16.02c1.16 2-.283 4.506-2.595 4.506H3.004c-2.312 0-3.755-2.505-2.595-4.505l9.292-16.02A2.972 2.972 0 0112.296 0z"}})]),_c('path',{attrs:{"data-name":"Trazado 196","d":"M11.26 6.234v8.724h2.059V6.234zm1.037 9.96a1.187 1.187 0 00-.841.329 1.044 1.044 0 00-.35.79 1.043 1.043 0 00.351.789 1.186 1.186 0 00.84.328 1.184 1.184 0 00.841-.328 1.045 1.045 0 00.349-.789 1.045 1.045 0 00-.349-.79 1.183 1.183 0 00-.841-.329z","fill":"#fff"}})])])
          )
        }
      }
    